import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';

import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { Patient } from '../models/index';
import { Api, Session, States } from '../services/index';
import { EmailExistsResult } from '../../app/models/authorization';
import { Observable } from 'rxjs';
import * as moment from 'moment';
import * as _ from 'lodash';

import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-family-member',
  templateUrl: './family-member.html',
  styleUrls: ['./family-member.css']
})

export class FamilyMemberComponent implements OnInit {
  avatar: string = '../../assets/images/ico-profile.png';
  birthdayFormGroup: FormGroup;
  dependentId: number;
    filesToUpload: Array<File> = [];
  fileTypes = 'image/png image/jpeg image/gif';
  isGUID: boolean = false;
  loading: boolean = false;
  orgPatient: Patient = new Patient;
  patient: Patient = new Patient;
  patientFormGroup: FormGroup;
  primaryPatient: Patient;
  requestExam: boolean = false;
  isSpanish: boolean = false;
  months: Array<any> = [{ 'value': '', 'name': 'Select Month' }];
  days: Array<any> = [{ 'value': '', 'name': 'Select Day' }];
  years: Array<any> = [{ 'value': '', 'name': 'Select Year' }];
  _subscription: any;
  langSelected: string = '';
  public GenderSelect: Object = [{ text: "Male", 'value': 'M' }, { text: "Female", 'value': 'F' }, { text: "Other", 'value': 'O' }];
  public genderFields: Object = { text: 'text', value: 'value' };
  public stateFields: Object = { text: 'name', value: 'abbreviation' };
  stateList: any[];
  patientBirthDate: string;

  
  constructor(private api: Api,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private service: NotificationsService,
    private session: Session,
    private changeDetectorRef: ChangeDetectorRef,
    private translateService: TranslateService,
    private states: States) {
    this.dependentId = this.route.snapshot.params['dependentId'] || '0';
    this.requestExam = this.route.snapshot.queryParams['requestExam'] || false;
    this.patientBirthDate = '01/01/1900';
    this._subscription = session.langChange.subscribe((value) => {
      this.langSelected = value;
      this.getBithdayDefaults();
    });

    if (this.session.selectedLang === 'en') {
      this.months = this.states.getMonths();
      this.days = this.states.getDays();
      this.years = this.states.getYears();
    } else if (this.session.selectedLang === 'es') {
      this.months = this.states.getMonthsES();
      this.days = this.states.getDaysES();
      this.years = this.states.getYearsES();
    } else {
      this.months = this.states.getMonths();
      this.days = this.states.getDays();
      this.years = this.states.getYears();
    }



    this.birthdayFormGroup = this.fb.group({
      'month': new FormControl('', Validators.required),
      'day': new FormControl('', Validators.required),
      'year': new FormControl('', Validators.required)
    }, {
        validator: this.dateValidator
      });

    this.patientFormGroup = this.fb.group({
      'firstName': new FormControl(this.patient.profile.firstName, Validators.required),
      'lastName': new FormControl(this.patient.profile.lastName, Validators.required),
      'dob': new FormControl(this.patient.profile.dateOfBirth),
      'phone': new FormControl(this.patient.phoneNumber),
      'phoneNumber': new FormControl(
        this.patient.phoneNumber,
        [Validators.compose([
          Validators.minLength(10),
          Validators.maxLength(14),
          Validators.pattern(/^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i)
        ]),
        Validators.required
        ]),
      'gender': new FormControl(this.patient.profile.gender, Validators.required),
      'address1': new FormControl(this.patient.profile.address1, Validators.required),
      'address2': new FormControl(this.patient.profile.address2),
      'city': new FormControl(this.patient.profile.city, Validators.required),
      'state': new FormControl(this.patient.profile.state, Validators.required),
      'zipCode': new FormControl(this.patient.profile.zipCode, [Validators.required, Validators.minLength(5)]),
      'parentRelationship': new FormControl(this.patient.parentRelationship, Validators.required),
      'email': new FormControl(this.patient.email, [this.emailOrEmpty])
    });

    //this.patientFormGroup.get('birthdayFormGroup').valueChanges.subscribe(data => this.onBirthdayValueChanged(data));
  }
 //Focus Event function for input component
 public focusIn(target: HTMLElement): void {
  target.parentElement.classList.add('e-input-focus');
}

//FocusOut Event function for input component
public focusOut(target: HTMLElement): void {
  target.parentElement.classList.remove('e-input-focus');
}

//Focus Event function for input component
public focusInLeft(target: HTMLElement): void {
  target.parentElement.parentElement.classList.add('e-input-focus');
}

//FocusOut Event function for input component
public focusOutLeft(target: HTMLElement): void {
  target.parentElement.parentElement.classList.remove('e-input-focus');
}

//MouseDown Event function for input component
public onMouseDown(target: HTMLElement): void {
  target.classList.add('e-input-btn-ripple');
}

//MouseUp Event function for input component
public onMouseUp(target: HTMLElement): void {
  let ele: HTMLElement = target;
  setTimeout(
    () => { ele.classList.remove('e-input-btn-ripple'); },
    500);
}
  dateValidator(control: FormGroup) {
    if (control.controls.month.value && control.controls.day.value && control.controls.year.value) {
      let value = control.controls.month.value + '/' + control.controls.day.value + '/' + control.controls.year.value;
      if (value && value.length > 0) {
        let birthday: string = value;
        let age: number;

        let regex, today, birthDate, month;
        regex = /^(?:(?:(?:0?[13578]|1[02])(\/|-|\.)31)\1|(?:(?:0?[1,3-9]|1[0-2])(\/|-|\.)(?:29|30)\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:0?2(\/|-|\.)29\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:(?:0?[1-9])|(?:1[0-2]))(\/|-|\.)(?:0?[1-9]|1\d|2[0-8])\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/; //if no pattern provided
        if (!regex.test(birthday)) {
          return { 'invalidBirthday': true };
        }

        if (!age) {
          today = new Date();
          birthDate = new Date(birthday);
          age = today.getFullYear() - birthDate.getFullYear();
          month = today.getMonth() - birthDate.getMonth();
          if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
            age = age - 1;
          }
        }

        if (isNaN(age)) {
          age = -1;  //if age is invalid
        }

        if (age === -1) {
          return { 'invalidBirthday': true };
        }
      }
    }
  }

  emailOrEmpty(control: AbstractControl): ValidationErrors {
    if (!control.value) {
      return null;
    }
    return Validators.email(control);
  }

  getBithdayDefaults() {
    if (this.langSelected === 'en') {
      this.months = this.states.getMonths();
      this.days = this.states.getDays();
      this.years = this.states.getYears();
    } else if (this.langSelected === 'es') {
      this.months = this.states.getMonthsES();
      this.days = this.states.getDaysES();
      this.years = this.states.getYearsES();
    } else {
      this.months = this.states.getMonths();
      this.days = this.states.getDays();
      this.years = this.states.getYears();
    }

    if (!this.changeDetectorRef['destroyed']) {
      this.changeDetectorRef.detectChanges();
    }

  }

  dateUnder18Validator(control: any) {
    if (control.month && control.day && control.year) {
      let value = control.month + '/' + control.day + '/' + control.year;
      if (value && value.length > 0) {
        let birthday: string = value;
        let age: number;

        let today, birthDate, month;

        if (!age) {
          today = new Date();
          birthDate = new Date(birthday);
          age = today.getFullYear() - birthDate.getFullYear();
          month = today.getMonth() - birthDate.getMonth();
          if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
            age = age - 1;
          }
        }

        if (isNaN(age)) {
          age = -1;  //if age is invalid
        }

        if (age < 18) {
          return true;
        }

        return false;
      }
    }

    return true;
  }

  onBirthdayValueChanged(value: any) {
    let emailControl = this.patientFormGroup.get('email');
    let phoneControl = this.patientFormGroup.get('phoneNumber');
    // Using setValidators to add and remove validators. No better support for adding and removing validators to controller atm.
    // See issue: https://github.com/angular/angular/issues/10567

    let validatUnder18 = this.dateUnder18Validator(value);

    if (validatUnder18) {
      emailControl.setValidators([this.emailOrEmpty]);
      phoneControl.setValidators([
        Validators.minLength(10),
        Validators.maxLength(14),
        Validators.pattern(/^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i)
      ]);
    } else {
      emailControl.setValidators([this.emailOrEmpty, Validators.required]);
      phoneControl.setValidators([
        Validators.minLength(10),
        Validators.maxLength(14),
        Validators.pattern(/^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i),
        Validators.required
      ]);
    }
    phoneControl.updateValueAndValidity();
    emailControl.updateValueAndValidity(); //Need to call this to trigger a update
  }

  get address1() { return this.patientFormGroup.get('address1'); }
  get address2() { return this.patientFormGroup.get('address2'); }
  get city() { return this.patientFormGroup.get('city'); }
  get dateOfBirth() { return this.patientFormGroup.get('dateOfBirth'); }
  get email() { return this.patientFormGroup.get('email'); }
  get firstName() { return this.patientFormGroup.get('firstName'); }
  get gender() { return this.patientFormGroup.get('gender'); }
  get lastName() { return this.patientFormGroup.get('lastName'); }
  get parentRelationship() { return this.patientFormGroup.get('parentRelationship'); }
  get patientNotes() { return this.patientFormGroup.get('patientNotes'); }
  get phoneNumber() { return this.patientFormGroup.get('phoneNumber'); }
  get state() { return this.patientFormGroup.get('state'); }
  get zipCode() { return this.patientFormGroup.get('zipCode'); }

  getStateList() {
    return this.session.stateList;
  }

  ngOnInit() {

    this.stateList = this.getStateList();


    if (this.dependentId > 0) {
      this.getPatient(this.dependentId);
    } else {
      let patient = this.api.getPatientById(this.session.patientId);
      patient.subscribe(response => {
        this.primaryPatient = response;
        this.patient.profile.address1 = this.primaryPatient.profile.address1;
        this.patient.profile.address2 = this.primaryPatient.profile.address2;
        this.patient.profile.city = this.primaryPatient.profile.city;
        this.patient.profile.state = this.primaryPatient.profile.state;
        this.patient.profile.zipCode = this.primaryPatient.profile.zipCode;
      })
    }

    if (!this.changeDetectorRef['destroyed']) {
      this.changeDetectorRef.detectChanges();
    }

  }

  getPatient(patientId) {
    let patient = this.api.getMember(patientId);
    patient.subscribe(response => {
      this.patient = response;
      let tmpTime = moment(this.patient.profile.dateOfBirth, 'YYYY/MM/DD');
      this.patient.profile.month = tmpTime.format('MM');
      this.patient.profile.day = tmpTime.format('DD');
      this.patient.profile.year = tmpTime.format('YYYY');
      this.orgPatient = _.cloneDeep(this.patient);

      let bday = moment(this.patient.profile.dateOfBirth, 'YYYY/MM/DD');
      this.patientBirthDate = bday.format('MM/DD/YYYY');


      this.patientFormGroup = this.fb.group({
        'firstName': new FormControl(this.patient.profile.firstName, Validators.required),
        'lastName': new FormControl(this.patient.profile.lastName, Validators.required),
        'dob': new FormControl(this.patientBirthDate),
        'phone': new FormControl(this.patient.phoneNumber),
        'phoneNumber': new FormControl(
          this.patient.phoneNumber,
          [Validators.compose([
            Validators.minLength(10),
            Validators.maxLength(14),
            Validators.pattern(/^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i)
          ]),
          Validators.required
          ]),
        'gender': new FormControl(this.patient.profile.gender, Validators.required),
        'address1': new FormControl(this.patient.profile.address1, Validators.required),
        'address2': new FormControl(this.patient.profile.address2),
        'city': new FormControl(this.patient.profile.city, Validators.required),
        'state': new FormControl(this.patient.profile.state, Validators.required),
        'zipCode': new FormControl(this.patient.profile.zipCode, [Validators.required, Validators.minLength(5)]),
        'parentRelationship': new FormControl(this.patient.parentRelationship, Validators.required),
        'email': new FormControl(this.patient.email, [this.emailOrEmpty])
      });

      
      if (this.patient.avatar) {
        this.avatar = this.session.environment.settings.patientAvatarBucket + this.patient.avatar;
      } else if (this.patient.profile.gender.toUpperCase() == 'F') {
        this.avatar = '../../assets/images/patient-avatar-female.png';
      } else {
        this.avatar = '../../assets/images/patient-avatar-male.png';
      }
    })
  }

  cancel() {
    if (this.requestExam) {
      this.router.navigate(['/exam-request-care-today']);
    } else {
      this.router.navigate(['/dashboard-family']);
    }
  } 

  saveDemographics() {
    this.loading = true;
    this.patient.relationshipCode = this.patient.parentRelationship;
    let value = this.patient.profile.month + '/' + this.patient.profile.day + '/' + this.patient.profile.year;
    this.patient.profile.dateOfBirth = new Date(value);
    let patient: any;
    let emailCheck: Observable<EmailExistsResult>;

    this.patient.email = this.patientFormGroup.get('email').value;
    let isOver18 = this.checkIsOver18(this.patient.profile.dateOfBirth);
    
    if (isOver18) {
      emailCheck = this.api.emailExists(this.patientFormGroup.get('email').value);
      emailCheck.subscribe(emailResponse => {
        console.dir(emailResponse);
        if (emailResponse.emailExists) {
          this.loading = false;
          this.service.error('Email address already in use. Please use another email.');
        } else {
          if (this.dependentId > 0) {
            patient = this.api.updatePatient(this.patient.userId, this.patient);
          } else {
            if (this.session.selectedLang === 'en') {
              patient = this.api.createDependent(this.session.patientId, this.patient);
            } else {
              patient = this.api.createDependentES(this.session.patientId, this.patient);
            }

          }

          patient.subscribe(response => {
            this.patient = response;
            if (this.filesToUpload.length > 0) {
              this.uploadAvatar();
            } else {
              if (this.requestExam) {
                this.router.navigate(['/exam-request-care-today']);
              } else {
                this.router.navigate(['/dashboard-family']);
              }
              this.loading = false;
            }
            this.service.success('Save Successful');
          }, (error) => {
            this.loading = false;
            this.service.error('Patient Save Failed', 'There was an error while saving, contact MeMD Team');
          })
        }
      });
    } else {
      if (this.dependentId > 0) {
        patient = this.api.updatePatient(this.patient.userId, this.patient);
      } else {
        patient = this.api.createDependent(this.session.patientId, this.patient);
      }

      patient.subscribe(response => {
        this.patient = response;
        if (this.filesToUpload.length > 0) {
          this.uploadAvatar();
        } else {
          if (this.requestExam) {
            this.router.navigate(['/exam-request-care-today']);
          } else {
            this.router.navigate(['/dashboard-family']);
          }
          this.loading = false;
        }
        this.service.success('Save Successful');
      }, (error) => {
        this.loading = false;
        this.service.error('Patient Save Failed', 'There was an error while saving, contact MeMD Team');
      })
    }



  }

  fileChangeEvent(fileInput: any) {
    if (this.fileTypes.indexOf(fileInput.target.files[0].type) >= 0) {
      this.filesToUpload = <Array<File>>fileInput.target.files;
    } else {
      $('#uploadFileInput').val('');
      alert('Only file types of JPG, JPEG, PNG, and GIF are allowed to be uploaded');
    }
  }

  uploadAvatar() {
    if (this.filesToUpload.length > 0) {
      let file = this.filesToUpload[0];
      let createPatientAvatarRequest = this.api.createPatientAvatar(this.patient.userId, file);
      createPatientAvatarRequest.subscribe(avatar => {
        if (this.requestExam) {
          this.router.navigate(['/exam-request-care-today']);
        } else {
          this.router.navigate(['/dashboard']);
        }
        this.loading = false;
      }, err => {
        this.loading = false;
        this.service.error('Avatar Save Failed', 'There was an error while saving, contact MeMD Team');
      });
    }
  }
  checkIsOver18(date: Date) {
    let dateOfBirth = moment(date);
    let now = moment();
    return (now.diff(dateOfBirth, 'years') >= 18)
  }
  canDeactivate(): Observable<boolean> | boolean {
    // insert logic to check if there are pending changes here;
    // returning true will navigate without confirmation
    // returning false will show a confirm alert before navigating away
    if (JSON.stringify(this.patient) !== JSON.stringify(this.orgPatient)) {
      return false;
    }
    return true;
  }

  // @HostListener allows us to also guard against browser refresh, close, etc.
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    if (!this.canDeactivate()) {
      $event.returnValue = 'WARNING: You have unsaved changes. Press Cancel to go back and save these changes, or OK to lose these changes.';
    }
  }
}
